import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import useRefreshToken from "../Hooks/useRefreshToken";
import useAuth from "../Hooks/useAuth";
import Loader from "../Layout/Loader";
import useLocalStorage from "../Hooks/useLocalStorage";
import { useAppSelector } from "../redux/hooks/hook";
import { selectCurrentUser } from "../redux/features/auth/authSlice";
import useLogout from "../Hooks/useLogout";

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const { auth } = useAuth();
    const [persist] = useLocalStorage('persist', false);

    const curUser = useAppSelector(selectCurrentUser);
   
    //console.log(curUser);
    const logout = useLogout();

    useEffect(() => {
        let isMounted = true;

        const verifyRefreshToken = async () => {
            try {
                await refresh();
            }
            catch (err) {
                //console.error(err);
            }
            finally {
                isMounted && setIsLoading(false);
            }
        }

        // Avoids unwanted call to verifyRefreshToken
        //!auth?.accessToken && persist ? verifyRefreshToken() : setIsLoading(false);
        !curUser ? logout() : setIsLoading(false);

        return () => isMounted = false;
    }, [])

    useEffect(() => {
       // console.log(`isLoading: ${isLoading}`)
        //console.log(`auth: ${JSON.stringify(auth)}`)
       // console.log(`aT: ${JSON.stringify(auth?.accessToken)}`)
    }, [isLoading])

    return (
        <>
            {!persist
                ? <Outlet />
                : isLoading
                    ? <Loader/>
                    : <Outlet />
            }
        </>
    )
}

export default PersistLogin